const guiColors = {
    'motion-primary': '#8169FF',
    'motion-primary-transparent': '#8169FFE6',
    'motion-tertiary': '#9F42D8',

    'looks-secondary': '#8169FF',
    'looks-transparent': '#8169FF59',
    'looks-light-transparent': '#8169FF26',
    'looks-secondary-dark': '#9F42D8',

    'extensions-primary': '#8169FF',
    'extensions-tertiary': '#9F42D8',
    'extensions-transparent': '#8169FF59',
    'extensions-light': '#EBC8FF',

    'drop-highlight': '#DEA0FF'
};

const blockColors = {
    checkboxActiveBackground: '#8169FF',
    checkboxActiveBorder: '#9F42D8'
};

export {
    guiColors,
    blockColors
};
